import pkg from 'src/../package.json';

export default {
  app: {
    name: pkg?.name,
    version: pkg.version
  },
  env: {
    dev: process.env.NODE_ENV === 'development',
    test: process.env.NODE_ENV === 'test',
    prod: process.env.NODE_ENV === 'production',
    blipChatToken: process.env.REACT_APP_BLIPCHAT_TOKEN,
    movideskToken: process.env.REACT_APP_MOVIDESK_TOKEN
  },
  backend: {
    apiAccounts: process.env.REACT_APP_API_ACCOUNTS,
    apiAssembleias: process.env.REACT_APP_API_ASSEMBLEIAS
  },
  keys: {
    session: 'hub.votacao.session'
  }
};
